import React, { useState, useEffect } from "react";
import { PDFDocument, rgb, StandardFonts, degrees } from "pdf-lib";
import axios from "axios";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { getApplicantsByAllotmentPaymentId, getReraDocNumberForCP } from "../../Services/LeadService";
import { toast } from "react-toastify";

function InvoiceModal({
  open,
  onClose,
  leadData,
  invoiceDate,
  invoiceNumber,
  onInvoiceProcessComplete,
  onUploadComplete,
  handleFileUpload,
  handleUploadButtonClick,
  fileInputRef,
}) {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isGeneratingInvoice, setIsGeneratingInvoice] = useState(false);
  // const [bankDetails, setBankDetails] = useState(null);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [reraDocNumber, setReraDocNumber] = useState(null);
  const [applicants, setApplicants] = useState([]);
  const [isInvoiceValid, setIsInvoiceValid] = useState(true);

console.log('leads data---->',leadData);
const projectId = leadData?.projectData?.projectId;
const projectName = leadData?.projectData?.projectName;
const wingId = leadData?.wingData?.wingId;
console.log('projectId---->',projectName);

  useEffect(() => {
  const fetchApplicants = async () => {
    const allotmentPaymentId = leadData?.allotmentPaymentData?.allotmentPaymentId;
    if (!allotmentPaymentId) return;

    const result = await getApplicantsByAllotmentPaymentId(allotmentPaymentId);
    setApplicants(result || []);
  };

  if (open) {
    fetchApplicants();
  }
}, [open, leadData]);


function formatShortDate(dateValue) {
  if (!dateValue) return "NA";

  const date = new Date(dateValue);

  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear().toString().slice(-2);

  return `${day} ${month} ${year}`;
}

const formatSafeDate = (value) => {
  if (!value) return "NA";

  const num = Number(value);
  if (isNaN(num)) return "NA";

  const date = new Date(num);
  if (isNaN(date.getTime())) return "NA";

  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
  useEffect(() => {
    if (!open) return;

    const currentCpId = leadData?.CpId || leadData?.CpID || leadData?.cpId;
    if (currentCpId) {
      getReraDocNumberForCP(currentCpId).then((docNum) => {
        setReraDocNumber(docNum || "NA");
      });
    } else {
      setReraDocNumber("NA");
    }
  }, [open, leadData]);

  useEffect(() => {
    if (open && reraDocNumber !== null) {
      createInvoice();
    }
  }, [open, reraDocNumber]);

  function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  }

  const fetchBankDetails = async () => {
    try {
      console.log("insidebankdetails");
      const response = await axios.post(
        // "http://localhost:8050/cpInvoices/fetchFVBankDetailsFromLedgerId",
        "https://labour.vjerp.com:4423/cpInvoices/fetchFVBankDetailsFromLedgerId",
        {
          CP_FV_LedgerID: leadData?.CP_FV_LedgerID, // Assuming `CP_FV_LedgerID` is available in `leadData`
        }
      );
      console.log("response", response);

      const data = response?.data?.result?.[0]; // Still update state for UI if needed
      // console.log("insidebankdetails",data)
      return data;
    } catch (error) {
      console.error("Error fetching bank details:", error);
    }
  };


  const validateInvoiceData = (bankDetailsData) => {
      console.log('Received bankDetailsData:', bankDetailsData); 
  const errors = [];

  // Validate Bank Details
  if (!bankDetailsData) {
    errors.push("Bank details are missing.");
  } else {
    if (!bankDetailsData?.AccountName)
      errors.push("Bank Account Name is missing.");
    if (!bankDetailsData?.AccountNo)
      errors.push("Bank Account Number is missing.");
    if (!bankDetailsData?.IFSCCode)
      errors.push("IFSC Code is missing.");
  }

  // Validate other necessary fields
//   if (!leadData?.CP_Ladger_Name)
//    errors.push("CP Name is missing.");

//   if (!leadData?.CP_PAN)
//  errors.push("PAN Number is missing.");

//   if (!invoiceDate)
//     errors.push("Invoice Date is missing.");

//   if (!invoiceNumber)
//     errors.push("Invoice Number is missing.");

  return errors;
};
  const createInvoice = async (showWatermark = true) => {
    console.log("🧾 Using RERA Number:", reraDocNumber);

    const bankDetailsData = await fetchBankDetails(); // ← store locally

      // Validate invoice data
    // Validate invoice data
  const validationErrors = validateInvoiceData(bankDetailsData);

  if (validationErrors.length > 0) {
    // Show toast error messages for each missing field
    validationErrors.forEach((error) => toast.error(error));

    // Stop invoice generation process if data is invalid
    setIsInvoiceValid(false); // Mark the invoice as invalid
    setPdfUrl(null); // Prevent showing old/blank PDF
    setIsGeneratingInvoice(false); // Stop the "Generating Invoice" spinner
    return null; // Return early to prevent further execution
  } else {
    setIsInvoiceValid(true); // Mark the invoice as valid
  }

    // if (!bankDetailsData) {
    //   console.error("Bank details missing, aborting invoice creation");
    //   return;
    // }


    const getShortProjectName = (name = "") => {
  if (!name) return "-";

  const words = name.trim().split(" ");

  if (words.length === 1) return words[0].slice(0, 6);

  if (words.length === 2)
    return `${words[0].slice(0, 3)} ${words[1].slice(0, 3)}`;

  return words.map((w) => w[0]).join("").toUpperCase();
};
    function formatIndianCurrency(amount) {
      if (!amount || isNaN(amount)) return "0";

      const roundedAmount = Math.round(parseFloat(amount)); // Round to nearest integer
      const amountStr = roundedAmount.toString();

      const lastThree = amountStr.substring(amountStr.length - 3);
      const otherNumbers = amountStr.substring(0, amountStr.length - 3);

      const formattedRupees =
        otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        (otherNumbers ? "," : "") +
        lastThree;

      return formattedRupees;
    }

    function convertNumberToWords(amount) {
      if (typeof amount !== "number" || isNaN(amount)) {
        return "Zero Rupees Only";
      }

      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
      ];
      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];
      const teens = [
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      

      function twoDigitsToWords(n) {
        if (n < 10) return ones[n];
        if (n >= 10 && n < 20) return teens[n - 10];
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      }

      function threeDigitsToWords(n) {
        let str = "";
        if (Math.floor(n / 100) > 0) {
          str += ones[Math.floor(n / 100)] + " Hundred";
          n %= 100;
          if (n > 0) str += " ";
        }
        if (n > 0) str += twoDigitsToWords(n);
        return str;
      }

      function convertToWords(num) {
        if (num === 0) return "Zero";

        const crore = Math.floor(num / 10000000);
        const lakh = Math.floor((num % 10000000) / 100000);
        const thousand = Math.floor((num % 100000) / 1000);
        const hundred = Math.floor(num % 1000);

        let words = "";

        if (crore) words += twoDigitsToWords(crore) + " Crore ";
        if (lakh) words += twoDigitsToWords(lakh) + " Lakh ";
        if (thousand) words += twoDigitsToWords(thousand) + " Thousand ";
        if (hundred) words += threeDigitsToWords(hundred) + " ";

        return words.trim();
      }

      const [rupeesStr, paiseStr] = amount.toFixed(2).split(".");
      const rupees = parseInt(rupeesStr, 10);
      const paise = parseInt(paiseStr, 10);

      let result = "";

      if (rupees > 0) {
        result += convertToWords(rupees) + " Rupees";
      }

      if (paise > 0) {
        if (result) result += " and ";
        result += convertToWords(paise) + " Paise";
      }

      if (!result) result = "Zero Rupees";

      return result + " Only";
    }

    const leftColWidth = 335;
    const rightColLabelWidth = 80;
    const rightColValueWidth = 115;
    const fullTableWidth =
      leftColWidth + rightColLabelWidth + rightColValueWidth;

    if (showWatermark) {
      setIsGeneratingInvoice(true);
    }

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595, 842]); // A4 size
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const bold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const { height } = page.getSize();

    if (showWatermark) {
      const watermarkText = "PREVIEW";
      const watermarkFontSize = 30;
      const watermarkOpacity = 0.2;
      const watermarkRotation = degrees(45);

      for (let x = -300; x < 600; x += 200) {
        for (let y = -300; y < 900; y += 200) {
          page.drawText(watermarkText, {
            x,
            y,
            size: watermarkFontSize,
            font: bold,
            color: rgb(0.5, 0.7, 0.95),
            rotate: watermarkRotation,
            opacity: watermarkOpacity,
          });
        }
      }
    }

    // const rowHeight = 20;
    const startX = 30;
    const fullWidth = 530;
    let y = height - 50;

    const drawText = (text, x, y, opts = {}) => {
      page.drawText(text, {
        x,
        y,
        size: opts.size || 10,
        font: opts.bold ? bold : font,
        color: rgb(0, 0, 0),
      });
    };

    const drawBox = (x, y, w, h) => {
      page.drawRectangle({
        x,
        y,
        width: w,
        height: h,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
      });
    };

    const drawRow = (label, value, widthL = 200, widthR = 330) => {
      drawBox(startX, y, widthL, rowHeight);
      drawBox(startX + widthL, y, widthR, rowHeight);
      drawText(label, startX + 10, y + 5);
      drawText(value, startX + widthL + 10, y + 5);
      y -= rowHeight;
    };

    const pageWidth = page.getWidth();

    // Center-align TAX INVOICE
    const isUnregisteredGST = leadData?.CP_GST === "UnRegistered";
    const taxText = isUnregisteredGST ? "INVOICE" : "TAX INVOICE";
    const taxWidth = bold.widthOfTextAtSize(taxText, 14);
    drawText(taxText, (pageWidth - taxWidth) / 2, y, { size: 15, bold: true });

    y -= 18;

    // Center-align CP name
    const cpName = leadData?.CP_Ladger_Name || "cp name";
    const cpNameWidth = bold.widthOfTextAtSize(cpName, 13);
    drawText(cpName, (pageWidth - cpNameWidth) / 2, y, {
      size: 13,
      bold: true,
    });

    y -= 16;

    const cpAddress = leadData?.CP_Address || "cp address";
    const fontSize = 10;
    const padding = 10;
    const maxWidth = fullTableWidth - padding * 2; // total usable width

    const wrapText = (text, maxWidth, font, size) => {
      const words = text.split(" ");
      const lines = [];
      let currentLine = "";

      for (const word of words) {
        const testLine = currentLine ? currentLine + " " + word : word;
        const width = font.widthOfTextAtSize(testLine, size);
        if (width <= maxWidth) {
          currentLine = testLine;
        } else {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        }
      }

      if (currentLine) lines.push(currentLine);
      return lines;
    };

    const addressLines = wrapText(cpAddress, maxWidth, bold, fontSize);

    addressLines.forEach((line, i) => {
      const lineWidth = bold.widthOfTextAtSize(line, fontSize);
      const x = startX + (fullTableWidth - lineWidth) / 2;
      drawText(line, x, y - i * 15, { size: fontSize, bold: true });
    });

    y -= addressLines.length * 12 + 15; // update y after block

    // Table dimensions
    const tableStartY = y;
    // const leftColWidth = 315;
    // const rightColLabelWidth = 90;
    // const rightColValueWidth = 125;
    const rowHeight = 20;
    const tableHeight = rowHeight * 5;
    // const fullTableWidth = leftColWidth + rightColLabelWidth + rightColValueWidth;

    // Draw table outer border
    drawBox(startX, y - tableHeight + 15, fullTableWidth, tableHeight);

    // Draw vertical split lines
    drawBox(
      startX + leftColWidth,
      y - tableHeight + 15,
      rightColLabelWidth,
      tableHeight
    );
    drawBox(
      startX + leftColWidth + rightColLabelWidth,
      y - tableHeight + 15,
      rightColValueWidth,
      tableHeight
    );

    // Draw horizontal lines for right side rows (5 rows total)
    for (let i = 1; i <= 5; i++) {
      const lineY = y - i * rowHeight + 15;
      page.drawLine({
        start: { x: startX + leftColWidth, y: lineY },
        end: { x: startX + fullTableWidth, y: lineY },
        thickness: 1,
        color: rgb(0, 0, 0),
      });
    }

    // Left side "TO:" info
    const leftTexts = [
      "TO:",
      leadData?.Company_Name || "NA",
      leadData?.Company_Address || "NA",
      `GSTIN : ${leadData?.Company_GST || "NA"}`,
    ];

    leftTexts.forEach((text, i) => {
      drawText(text, startX + 5, y - rowHeight * i + 5 - 2, {
        bold: i === 0,
      });
    });

    // Right side invoice details (starting from top)
    const rightTexts = [
      ["INVOICE NO:", invoiceNumber || "NA"],
      ["INVOICE DATE:", invoiceDate || "NA"],
      ["RERA NO:", reraDocNumber || "NA"],
      ["PAN NO:", leadData?.CP_PAN || "NA"],
      ["GSTIN NO:", leadData?.CP_GST || "NA"],
    ];

    rightTexts.forEach((row, i) => {
      const labelX = startX + leftColWidth + 5;
      const valueX = labelX + rightColLabelWidth;
      const yPos = y - rowHeight * i + 5 - 2;
      drawText(row[0], labelX, yPos, { bold: true });
      drawText(row[1], valueX + 5, yPos);
    });

    const gapAfterText = 10;
    y -= tableHeight + 10; // Move down after table

    // "From" Section (Company details)
    // drawText("FROM:", startX + 5, y, { bold: true });
    // y -= gapAfterText;
    // y -= rowHeight;
    // drawRow("Company Name", leadData?.Company_Name || "NA");
    // drawRow("GSTIN", leadData?.Company_GST || "NA");
    // drawRow("RERA Number", "A51900011464");
    // drawRow("Channel Partner Pan Number:", leadData?.CP_PAN || "NA");

    y -= gapAfterText;

    const headers = ["Sr. No", "Particulars", "Tax rate", "Amount"];
    const colWidths = [40, 350, 70, 70];
    let x = startX;

    // Center each header based on column width
    headers.forEach((header, i) => {
      const colX =
        x + colWidths[i] / 2 - font.widthOfTextAtSize(header, 10) / 2; // Calculate the x to center text
      drawBox(x, y, colWidths[i], rowHeight);
      drawText(header, colX, y + 5, { bold: true }); // Center text in the box
      x += colWidths[i];
    });
    y -= rowHeight;
    console.log("leadData", leadData);
    const isAOP_POP =
  leadData?.BrokerageType === "AOP" ||
  leadData?.BrokerageType === "POP";

// Build Agreement Name from applicants array
const agreementName = (() => {
  const applicant = applicants?.[0]?.applicant;
  const first = applicant?.firstName || "";
  const middle = applicant?.middleName ? " " + applicant.middleName : "";
  const last = applicant?.lastName ? " " + applicant.lastName : "";
  return `${first}${middle}${last}`.trim() || "NA";
})();

// const brokerageText =  
//   projectId === "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" // pratik nagar projectId (excluding Building D)
//     ? `Brokerage Amount : 500000`
//     : `Brokerage % : ${leadData?.Brokerage_Persentage || "3"}%`;

const brokerageText =
  (wingId === "f61a1b3a-fc89-43e9-86e2-bee61dc884dd") // Building D
    ? `Brokerage % : ${leadData?.Brokerage_Persentage || "3"}%`
    : projectId === "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" // pratik nagar projectId
    ? `Brokerage Amount : 500000`
    : projectId !== "2ca8b225-5b97-4fa8-96f1-00b7a9f6d077" // any other projectId except pratik nagar
    ? `Brokerage % : ${leadData?.Brokerage_Persentage || "3"}%`
    : null;



// const contentLines = [
//   "Description of service provided",
//   `Customer Name : ${leadData?.personData?.name || "NA"}\n( ${agreementName} )`, // 👈 Two-line string
//   `Project Name  : ${leadData?.projectData?.projectName || "NA"}`,
//   `Wing          : ${leadData?.wingData?.wingName || "NA"}`,
//   `Flat No.      : ${leadData?.inventoryDataForLead?.unitNo || "NA"}`,
//   `Agreement Value     : ${
//     !isNaN(leadData?.Agreement_Value)
//       ? formatIndianCurrency(leadData.Agreement_Value)
//       : "NA"
//   }`,
//   // `Brokerage %   : ${leadData?.Brokerage_Persentage || "3"}%`,
//   brokerageText,
//   "Total Amount  :",
//   "CGST     : ",
//   "SGST     : ",
// ];


const isAOP = leadData?.BrokerageType === "AOP";
const isPOP = leadData?.BrokerageType === "POP";

// Only show tax rows that have a non-zero amount
const hasTaxAmount = (value) => (parseFloat(value) || 0) !== 0;
const taxLines = [
  ...(hasTaxAmount(leadData?.Brokerage_Amount_Tax_CGST) ? ["CGST     : "] : []),
  ...(hasTaxAmount(leadData?.Brokerage_Amount_Tax_SGST) ? ["SGST     : "] : []),
  ...(hasTaxAmount(leadData?.Brokerage_Amount_Tax_IGST) ? ["IGST     : "] : []),
];

const contentLines = isAOP_POP
  ? [
      "Description of service provided",
      `Project Name  : ${leadData?.projectData?.projectName || "NA"}`,

      // ✅ AOP
      ...(isAOP
        ? [
            ` Plan Name :${leadData?.planName || "NA"}`,
            ` FY :${leadData?.planName || "NA"}`,
            ` Brokerage  :${leadData?.Brokerage_Persentage ?? "NA"}%`,
          ]
        : []),

      // ✅ POP
      ...(isPOP
        ? [
            ` Plan Name :${leadData?.planName || "NA"}`,
            ` date :${formatShortDate(leadData?.popStartDate)} to ${formatShortDate(leadData?.popEndDate)}`,
            ` Brokerage  :${leadData?.Brokerage_Persentage ?? "NA"}%`,
          ]
        : []),

      "Total Amount  :",
      ...taxLines,
    ]
  : [
      "Description of service provided",
      `Customer Name : ${leadData?.personData?.name || "NA"}\n( ${agreementName} )`,
      `Project Name  : ${leadData?.projectData?.projectName || "NA"}`,
      `Wing          : ${leadData?.wingData?.wingName || "NA"}`,
      `Flat No.      : ${leadData?.inventoryDataForLead?.unitNo || "NA"}`,
      `Agreement Value     : ${
        !isNaN(leadData?.Agreement_Value)
          ? formatIndianCurrency(leadData.Agreement_Value)
          : "NA"
      }`,
      brokerageText,
      "Total Amount  :",
      ...taxLines,
    ];


    const contentBlockHeight = rowHeight * contentLines.length+8; // Increased height
    x = startX;
    for (let i = 0; i < colWidths.length; i++) {
      drawBox(
        x,
        y - contentBlockHeight + rowHeight,
        colWidths[i],
        contentBlockHeight
      );
      x += colWidths[i];
    }

    drawText("1", startX + 5, y - 15, { bold: true });
    contentLines.forEach((line, i) => {
  const [label, ...rest] = line.split(":");
  const value = rest.join(":").trim();

  // Base Y for first line
  let baseY = y - rowHeight * i + 5;

  if (label.trim() === "Customer Name" && value.includes("\n")) {
    const [mainValue, agreementValue] = value.split("\n");

    // Label position
    drawText(`${label.trim()} :`, startX + colWidths[0] + 5, baseY, { bold: true });

    // Calculate exact value X so it matches other fields
    const valueX = startX + colWidths[0] + 120;

    // First line (Customer Name)
    drawText(mainValue.trim(), valueX, baseY);

    // Second line (Agreement Name) right below with tighter spacing
    drawText(agreementValue.trim(), valueX, baseY - 11, { size: 9 });
      y -= gapAfterText

  } else {
    drawText(`${label.trim()} :`, startX + colWidths[0] + 5, baseY, { bold: true });
    drawText(value, startX + colWidths[0] + 120, baseY);
  }
});

    // drawText(
    //   formatIndianCurrency(leadData?.Brokerage_Amount_Basic),
    //   startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    //   y - rowHeight * 7 + 5
    // );

    // // Drawing the first rate text
    // drawText(
    //   "9%",
    //   startX + colWidths[0] + colWidths[1] + 5,
    //   y - rowHeight * 9 + 5
    // );

    // // Drawing the SGST amount
    // drawText(
    //   formatIndianCurrency(leadData?.Brokerage_Amount_Tax_SGST || "NA"),
    //   startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    //   y - rowHeight * 9 + 5
    // );

    // // Drawing the second rate text
    // drawText(
    //   "9%",
    //   startX + colWidths[0] + colWidths[1] + 5,
    //   y - rowHeight * 8 + 5
    // );

    // // Drawing the CGST amount for second rate
    // drawText(
    //   formatIndianCurrency(leadData?.Brokerage_Amount_Tax_CGST || "NA"),
    //   startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    //   y - rowHeight * 8 + 5
    // );



    // 🔥 Find correct row positions dynamically
const totalIndex = contentLines.findIndex(l => l.includes("Total Amount"));
const cgstIndex = contentLines.findIndex(l => l.includes("CGST"));
const sgstIndex = contentLines.findIndex(l => l.includes("SGST"));
const igstIndex = contentLines.findIndex(l => l.includes("IGST"));

// TOTAL
if (totalIndex !== -1) {
  drawText(
    formatIndianCurrency(leadData?.Brokerage_Amount_Basic),
    startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    y - rowHeight * totalIndex + 5
  );
}

// CGST
if (cgstIndex !== -1) {
  drawText(
    "9%",
    startX + colWidths[0] + colWidths[1] + 5,
    y - rowHeight * cgstIndex + 5
  );

  drawText(
    formatIndianCurrency(leadData?.Brokerage_Amount_Tax_CGST || 0),
    startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    y - rowHeight * cgstIndex + 5
  );
}

// SGST
if (sgstIndex !== -1) {
  drawText(
    "9%",
    startX + colWidths[0] + colWidths[1] + 5,
    y - rowHeight * sgstIndex + 5
  );

  drawText(
    formatIndianCurrency(leadData?.Brokerage_Amount_Tax_SGST || 0),
    startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    y - rowHeight * sgstIndex + 5
  );
}

// IGST
if (igstIndex !== -1) {
  drawText(
    "18%",
    startX + colWidths[0] + colWidths[1] + 5,
    y - rowHeight * igstIndex + 5
  );

  drawText(
    formatIndianCurrency(leadData?.Brokerage_Amount_Tax_IGST || 0),
    startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
    y - rowHeight * igstIndex + 5
  );
}

    y -= contentBlockHeight; // Adjust y for the increased content block

    const totalAmount = Math.round(
      (parseFloat(leadData?.Brokerage_Amount_Basic) || 0) +
        (parseFloat(leadData?.Brokerage_Amount_Tax_SGST) || 0) +
        (parseFloat(leadData?.Brokerage_Amount_Tax_CGST) || 0) +
        (parseFloat(leadData?.Brokerage_Amount_Tax_IGST) || 0)
    );

    // Total Section
    drawBox(startX, y-10, colWidths[0] + colWidths[1] + colWidths[2], rowHeight);
    drawBox(
      startX + colWidths[0] + colWidths[1] + colWidths[2],
      y-10,
      colWidths[3],
      rowHeight
    );
    drawText("TOTAL", startX + 5, y-5 , { bold: true });
    drawText(
      formatIndianCurrency(totalAmount),
      startX + colWidths[0] + colWidths[1] + colWidths[2] + 5,
      y-5
    );

    y -= rowHeight;

    // Amount in Words
    drawBox(
      startX,
      y-10,
      colWidths.reduce((a, b) => a + b),
      rowHeight
    );
    const totalAmountInWords = convertNumberToWords(totalAmount);
    drawText(`Amount in Words: ${totalAmountInWords}`, startX + 5, y -5, {
      bold: true,
    });
    y -= rowHeight + 10; // Adjust for the spacing after amount

    const footerBoxHeight = 90;
    const footerBoxWidth = colWidths.reduce((a, b) => a + b);
    drawBox(startX, y - footerBoxHeight, footerBoxWidth, footerBoxHeight);

    const footerLines = [
      `Channel Partner Name : ${leadData?.CP_Ladger_Name || "NA"}`,
      `Bank Name  : ${bankDetailsData?.AccountName}`,
      `Account No : ${bankDetailsData?.AccountNo}`,
      `IFSC code  : ${bankDetailsData?.IFSCCode}`,
      "(As per RERA certificate)",
    ];
    footerLines.forEach((line, i) => {
      drawText(line, startX + 8, y - 15 * (i + 1), { bold: i === 4 });
    });

    drawText(
      "Authorised Signatory",
      startX + footerBoxWidth - 130,
      y - footerBoxHeight + 10,
      { bold: true }
    );

    // ✅ 🔥 ADD ANNEXURE HERE (EXACT PLACE)
// ✅ 🔥 ANNEXURE TABLE FORMAT
if (isAOP_POP) {
  page.drawText("* Please refer to the Annexure (next page) for detailed unit-wise brokerage information.", {
    x: 30,
    y: y - footerBoxHeight - 20,
    size: 9,
    font: font,
    color: rgb(0.2, 0.2, 0.2),
  });

  const annexurePage = pdfDoc.addPage([595, 842]);
  const { height } = annexurePage.getSize();
  // Page currently being drawn on — switches when rows overflow onto a new page
  let currentPage = annexurePage;

  let yPos = height - 60;
  const startX = 30;
  const maxTableWidth = 535;

  if (showWatermark) {
    for (let wx = -300; wx < 600; wx += 200) {
      for (let wy = -300; wy < 900; wy += 200) {
        annexurePage.drawText("PREVIEW", {
          x: wx,
          y: wy,
          size: 30,
          font: bold,
          color: rgb(0.5, 0.7, 0.95),
          rotate: degrees(45),
          opacity: 0.2,
        });
      }
    }
  }

  const fontSize = 9;
  const headerFontSize = 9;
  const cellPad = 4;

  const headers = [
    "Sr",
    "Customer Name",
    "Project",
    "Wing",
    "Unit",
    "Agreement Date",
    "Agreement Value",
    "Brokerage",
  ];

  const rows = leadData?.annexureRows || [];
  console.log("Annexure rows:", rows);

  // 🔥 Fixed proportional column widths (weights sum to 1) so the layout is
  //    predictable and headers always have room — no content-driven shrinking.
  const colWeights = [0.05, 0.22, 0.10, 0.14, 0.09, 0.12, 0.15, 0.13];
  const colWidths = colWeights.map((w) => w * maxTableWidth);

  const rowHeight = 25;
  const headerHeight = 32;

  // Shrink font until the text fits within the given width (down to a min size)
  const fitFontSize = (text, maxWidth, f, baseSize, minSize = 6) => {
    let size = baseSize;
    while (size > minSize && f.widthOfTextAtSize(String(text), size) > maxWidth) {
      size -= 0.5;
    }
    return size;
  };

  // Wrap text into multiple lines that each fit within maxWidth
  const wrapText = (text, maxWidth, f, size) => {
    const words = String(text).split(" ");
    const lines = [];
    let current = "";
    words.forEach((word) => {
      const test = current ? `${current} ${word}` : word;
      if (!current || f.widthOfTextAtSize(test, size) <= maxWidth) {
        current = test;
      } else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    return lines;
  };

  const drawCell = (text, x, y, width) => {
    currentPage.drawRectangle({
      x,
      y,
      width,
      height: rowHeight,
      borderWidth: 1,
      borderColor: rgb(0, 0, 0),
    });

    const str = String(text ?? "NA");
    const size = fitFontSize(str, width - cellPad * 2, font, fontSize);
    currentPage.drawText(str, {
      x: x + cellPad,
      y: y + 8,
      size,
      font,
    });
  };

  // TITLE
  annexurePage.drawText("ANNEXURE", {
    x: 240,
    y: yPos,
    size: 16,
    font: bold,
  });

  yPos -= 40;

  // HEADER — wrap multi-word labels across lines and vertically centre them
  let x = startX;
  const headerBottom = yPos - (headerHeight - rowHeight);
  const headerLineHeight = headerFontSize + 2;
  headers.forEach((h, i) => {
    annexurePage.drawRectangle({
      x,
      y: headerBottom,
      width: colWidths[i],
      height: headerHeight,
      borderWidth: 1,
      borderColor: rgb(0, 0, 0),
    });

    const lines = wrapText(h, colWidths[i] - cellPad * 2, bold, headerFontSize);
    const blockHeight = lines.length * headerLineHeight;
    let textY = headerBottom + (headerHeight + blockHeight) / 2 - headerLineHeight + 1;
    lines.forEach((line) => {
      annexurePage.drawText(line, {
        x: x + cellPad,
        y: textY,
        size: headerFontSize,
        font: bold,
      });
      textY -= headerLineHeight;
    });

    x += colWidths[i];
  });

  yPos -= headerHeight;

  // ROWS
  rows.forEach((row, index) => {
    console.log("Drawing annexure row:", row);
    let x = startX;

    const rowData = [
      index + 1,
      row.leadName,
    row.projectShortCode || "NA",
      row.wingName,
      row.unitNo,
  formatShortDate(row.agreementDate),
      formatIndianCurrency(row.agreementValue),
      formatIndianCurrency(row.brokerageAmountBasic),
    ];

    rowData.forEach((cell, i) => {
      drawCell(cell, x, yPos, colWidths[i]);
      x += colWidths[i];
    });

    yPos -= rowHeight;

    if (yPos < 60) {
      const newPage = pdfDoc.addPage([595, 842]);
      if (showWatermark) {
        for (let wx = -300; wx < 600; wx += 200) {
          for (let wy = -300; wy < 900; wy += 200) {
            newPage.drawText("PREVIEW", {
              x: wx,
              y: wy,
              size: 30,
              font: bold,
              color: rgb(0.5, 0.7, 0.95),
              rotate: degrees(45),
              opacity: 0.2,
            });
          }
        }
      }
      currentPage = newPage;
      yPos = height - 60;
    }
  });

  // TOTAL ROW — sum of "Value" (agreementValue) column
  const totalAgreementValue = rows.reduce((sum, row) => sum + (parseFloat(row.agreementValue) || 0), 0);
  const totalBrokerage = rows.reduce((sum, row) => sum + (parseFloat(row.brokerageAmountBasic) || 0), 0);

  const valueColIndex = 6;    // "Value" column
  const brokerageColIndex = 7; // "Brokerage" column

  // Merge the leading columns (Sr..Date) into one cell so the "Total" label
  // has room and doesn't get cut by the next column's border line.
  let totalX = startX;
  const labelWidth = colWidths
    .slice(0, valueColIndex)
    .reduce((a, b) => a + b, 0);

  currentPage.drawRectangle({
    x: totalX,
    y: yPos,
    width: labelWidth,
    height: rowHeight,
    borderWidth: 1,
    borderColor: rgb(0, 0, 0),
  });
  const totalLabel = "Total";
  currentPage.drawText(totalLabel, {
    x: totalX + labelWidth - bold.widthOfTextAtSize(totalLabel, 10) - cellPad - 2,
    y: yPos + 8,
    size: 10,
    font: bold,
  });
  totalX += labelWidth;

  [valueColIndex, brokerageColIndex].forEach((i) => {
    currentPage.drawRectangle({
      x: totalX,
      y: yPos,
      width: colWidths[i],
      height: rowHeight,
      borderWidth: 1,
      borderColor: rgb(0, 0, 0),
    });
    const txt = formatIndianCurrency(
      i === valueColIndex ? totalAgreementValue : totalBrokerage
    );
    const size = fitFontSize(txt, colWidths[i] - cellPad * 2, bold, 10);
    currentPage.drawText(txt, {
      x: totalX + cellPad,
      y: yPos + 8,
      size,
      font: bold,
    });
    totalX += colWidths[i];
  });
}
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    if (showWatermark) {
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);

      // Store in localStorage
      localStorage.setItem("generatedInvoiceUrl", url);
      localStorage.setItem("invoiceDate", invoiceDate);
      localStorage.setItem("invoiceNumber", invoiceNumber);

      setIsGeneratingInvoice(false);
      return;
    }

    return blob; // For downloading without watermark
  };
  // useEffect(() => {
  //   if (open) createInvoice();
  // }, [open]);

  if (!open) return null;

  const handleDownloadPdf = async () => {
    const pdfBlob = await createInvoice(false); // Generate without watermark
    const url = URL.createObjectURL(pdfBlob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `Invoice_${leadData?.id || "download"}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <span
          onClick={onClose}
          style={{
            position: "absolute",
            top: "1.2rem",
            right: "1.2rem",
            cursor: "pointer",
            display: "flex",
          }}
        >
          <CloseIcon style={{ fontSize: "2.8rem" }} />
        </span>
        <h2 style={{ marginBottom: "1rem" }}>Invoice Preview</h2>
        {isGeneratingInvoice ? (
          <div>Generating invoice...</div>
        ) : isMobileDevice() ? (
          <div style={{ textAlign: "center", marginBottom: "1rem" }}>
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                padding: "1rem 2rem",

                fontSize: "2rem", // 👈 Increased font size
                fontWeight: "bold",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#175cd3")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#1570EF")
              }
            >
              Open Invoice in PDF Viewer
            </a>
          </div>
        ) : (
          <embed
            src={pdfUrl}
            width="100%"
            height="500px"
            type="application/pdf"
            style={{ border: "1px solid #ccc", marginBottom: "1rem" }}
          />
        )}

        <input
          type="file"
          accept="application/pdf"
          ref={fileInputRef}
          onChange={(e) =>
            handleFileUpload(e, onUploadComplete, onInvoiceProcessComplete)
          }
          style={{ display: "none" }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            flexWrap: "wrap",
          }}
        >
          {/* Download Button */}
          {/* {pdfUrl && (
            <a
              href={pdfUrl}
              download={`Invoice_${leadData?.id || "download"}.pdf`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                backgroundColor: "#1570EF",
                color: "#fff",
                textDecoration: "none",
                padding: "0.8rem 1.6rem",
                borderRadius: "4px",
                fontSize: "1.4rem",
                transition: "background-color 0.3s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#175cd3")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#1570EF")
              }
            >
              <FileDownloadOutlinedIcon fontSize="large" />
              Download Invoice
            </a>
          )} */}

          <button
            onClick={handleDownloadPdf}
             disabled={!isInvoiceValid}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              backgroundColor: "#1570EF",
              color: "#fff",
              border: "none",
              padding: "0.8rem 1.6rem",
              borderRadius: "4px",
              fontSize: "1.4rem",
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#175cd3")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#1570EF")
            }
          >
            <FileDownloadOutlinedIcon fontSize="large" />
            Download Invoice
          </button>

          {/* Upload Button */}
          <button
            onClick={() => setShowUploadDialog(true)} // Show dialog on click
             disabled={!isInvoiceValid}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              backgroundColor: isInvoiceValid ? "#1570EF" : "#ccc",
              color: "#fff",
              border: "none",
              padding: "0.8rem 1.6rem",
              borderRadius: "4px",
              fontSize: "1.4rem",
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#175cd3")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#1570EF")
            }
          >
            <FileUploadOutlinedIcon fontSize="large" />
            Upload Invoice
          </button>

          {/* Close Button */}
          {/* <button
    onClick={() =>
      onInvoiceProcessComplete ? onInvoiceProcessComplete() : onClose()
    }
    style={{
      backgroundColor: "#ccc",
      padding: "0.6rem 1.2rem",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "1.4rem",
    }}
  >
    Close
  </button> */}
        </div>

        {showUploadDialog && (
          <div style={styles.dialogOverlay}>
            <div style={styles.dialogBox}>
              <h2
                style={{
                  fontSize: "2rem",
                  marginBottom: "1.5rem",
                  textAlign: "center",
                }}
              >
                Confirm Invoice Upload
              </h2>

              <p
                style={{
                  fontSize: "1.8rem",
                  marginBottom: "1rem",
                  textAlign: "center",
                }}
              >
                Are you sure you want to proceed with uploading this invoice?
              </p>

              <ul
                style={{
                  fontSize: "1.3rem",
                  margin: "1rem 0",
                  paddingLeft: "1.2rem",
                  lineHeight: "1.8",
                  textAlign: "left",
                }}
              >
                <li>
                  The invoice number and invoice date are entered correctly.
                </li>
                <li>
                  The <b>Billing Name</b>, <b>GST Number</b> , and{" "}
                  <b>Billing Address</b> match your official records.
                </li>
              </ul>
              <h2
                style={{
                  fontSize: "1.4rem",
                  marginBottom: "1.5rem",
                  color: "red",
                  textAlign: "left",
                }}
              >
                NOTE : Once submitted, the invoice details will be locked for
                processing.
              </h2>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                  marginTop: "2rem",
                }}
              >
                <button
                  onClick={() => setShowUploadDialog(false)}
                  style={{
                    padding: "0.8rem 2rem",
                    fontSize: "1.3rem",
                    backgroundColor: "#ccc",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowUploadDialog(false);
                    handleUploadButtonClick();
                  }}
                  style={{
                    padding: "0.8rem 2rem",
                    fontSize: "1.3rem",
                    backgroundColor: "#1570EF",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    position: "relative",
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "900px",
    boxShadow: "0 0 20px rgba(0,0,0,0.3)",
  },
  dialogOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100vw",
    backgroundColor: "rgba(0,0,0,0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10000,
  },
  dialogBox: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "8px",
    width: "90%",
    maxWidth: "600px",
    margin: "0 1rem", // padding for mobile side gaps
    boxShadow: "0 0 20px rgba(0,0,0,0.2)",
    textAlign: "center",
    boxSizing: "border-box",
  },

  successPopup: {
    position: "fixed",
    bottom: "2rem",
    right: "2rem",
    backgroundColor: "#28a745",
    color: "#fff",
    padding: "1rem 2rem",
    borderRadius: "8px",
    fontSize: "1.4rem",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    zIndex: 10001,
  },
};

export default InvoiceModal;